import React, { useContext,useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate,Link} from "react-router-dom";
import LoginForm from './components/LoginForm';
import TractumStartPage from './pages/StartForm';
import ProductsPage from "./pages/ProductPage";
import NotebookRouteWrapper from "./NotebookRouteWrapper";
import ProtectedRoute from "./components/ProtectedRoute";
import { isTokenValid } from "./utils/auth";

import TractumUI from "./TractumUI/TractumUI";
import { ContextEngine } from "./TractumUI/engine/ContextEngine";
import './index.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // This saves your 1GB RAM server from constant refetching
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1, // Only retry once if Flask is busy
    },
  },
});

function App() {
  const { context,updateContext } = useContext(ContextEngine);
  const user = context?.user; 

  const handleLogout = () => {
    updateContext("user",null)
  };
  const isLoggedIn = user?.token && isTokenValid(user.token);

  console.log('isLoggedIn',isLoggedIn);

  
  return (
    <QueryClientProvider client={queryClient}>
    <Routes>
      <Route path="/" element={
        isLoggedIn ? <Navigate to="/tenants" /> : <Navigate to="/tractum" />
      } />
      
      {/* Update all other routes to use 'isLoggedIn' */}
      <Route path="/tracta" element={isLoggedIn ? <TractumUI /> : <TractumStartPage />} />
      <Route path="/login" element={
        <LoginForm onLogin={() => {
          // This can be empty now because updateContext handles the heavy lifting
          console.log("Login callback triggered");
        }} />
      } />

      <Route path="/tenants" element={
        isLoggedIn ? (
        <ProtectedRoute token={user?.token}>
          <NotebookRouteWrapper
            // 🚀 NO MORE localStorage.getItem('tenants')!
            // Use the data already in your "Class" object
            tenants={user?.tenants} 
            user={user}
            onLogout={handleLogout}
          />
        </ProtectedRoute>
        ) : (
          <Navigate to="/login" />
        )
      } />
      <Route path="/tractum" element={isLoggedIn ? <TractumStartPage /> : <Navigate to="/login" />} />

      {/* Products page (public) */}
      <Route path="/products" element={<ProductsPage />} />


      {/* Tenant list - protected
      <Route path="/tenants" element={
        <ProtectedRoute token={user?.token}>
          <TenantList
            user={user} // Pass the whole object
            setLoading={setLoading}
            onTenantsFetched={setTenants}
          />
        </ProtectedRoute>
      } /> */}

      {/* Notebook route - protected */}
      <Route path="/:project/:user/:notebook/:page/:folder/get-notebook" element={
        <ProtectedRoute token={user?.token}>
          <NotebookRouteWrapper
            // 🚀 NO MORE localStorage.getItem('tenants')!
            // Use the data already in your "Class" object
            tenants={user?.tenants} 
            user={user}
            onLogout={handleLogout}
          />
        </ProtectedRoute>
      } />
    </Routes>
    </QueryClientProvider>
  );
}
export default App;
